import React, { useContext } from 'react';
import { BiBed } from 'react-icons/bi';
import { HouseContext } from './HouseContext';
import FilterDropdown from './FilterDropdown';

//* '(any)' is what HouseList expects for "no bedroom filter"
const bedroomOptions = [
    { label: 'Bedrooms (any)', value: '(any)' },
    { label: '2 bedrooms', value: '2' },
    { label: '3 bedrooms', value: '3' },
    { label: '4 bedrooms', value: '4' },
    { label: '5 bedrooms', value: '5' },
];

const BedroomsDropdown = ({ onChange, isOpen, onToggle, onClose, className }) => {
    const { bedrooms, setBedrooms } = useContext(HouseContext);

    //? Context default is 'Bedrooms (any)', which is not one of the option values,
    //? so the button falls back to the plain "Bedrooms" label until a choice is made.
    const value = bedroomOptions.some((option) => option.value === bedrooms) ? bedrooms : null;

    const handleSelect = (option) => {
        setBedrooms(option);
        onClose();
        if (onChange) {
            onChange(option);
        }
    };

    return (
        <FilterDropdown
            icon={BiBed}
            label="Bedrooms"
            value={value}
            options={bedroomOptions}
            isOpen={isOpen}
            onToggle={onToggle}
            onClose={onClose}
            onSelect={handleSelect}
            className={className}
        />
    );
};

export default BedroomsDropdown;
